import { isNil } from 'lodash/fp';
import { extractViewId } from 'app/store/utils';

const OPERATION_UID_PATTERN = /^_v\d+_op\d+$/;
const isOperationUid = (uid: string) => OPERATION_UID_PATTERN.test(uid);

export function getDatasetErrors(viewUid: string, errorsByUid?: Record<string, unknown>) {
    if (isNil(errorsByUid)) {
        return null;
    }

    if (viewUid in errorsByUid) {
        return errorsByUid[viewUid];
    }

    const operationUidKey = Object.keys(errorsByUid).find(
        (key) => isOperationUid(key) && extractViewId(key) === viewUid
    );
    return operationUidKey ? errorsByUid[operationUidKey] : null;
}
